export default function (context) {
    context.commit('loading', true);
    axios({
        method: 'post',
        url: '/tourclient/statistic/getStatistic',
        requestId: 'tourclient/statistic/getStatistic'
    }).then(({data}) => {
        if (data) {
            context.commit('buttons', data);
            context.commit('orders', data);
            context.commit('chart', data);
            context.commit('events', data);
        }
        setTimeout(() => {
            context.commit('loading', false);
        })
    }).catch(e => {
        context.commit('loading', false);
        context.dispatch('error', e, {root: true});
    });
}